
<div class=" mb-0 mt-1 bg-color mx-3 px-1 portal-card"  *ngIf="isShow" [ngClass]="{ 'isActive': isActive }" (click)="onCardHandler()">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <img
          [src]="imageSource"
          alt="image"
          class="me-3 d-none d-sm-block rounded-circle"
        />
        <div class="w-100 overflow-hidden">
          <h5 class="mb-0 header-title">{{cardTitle}}</h5>
          <p class="mb-0">{{cardDescription}}</p>
        </div>
        <!-- <span class="dragula-handle"></span> -->
      </div>
    </div>
  </div>